export function manageHotelInitialData(hotels: any) {
  const hotelsInitialData: {
    hotel_id: number
    check_in: string
    check_out: string
    total_night: number
    total_rooms: number
    rooms: any[]
    conversion_rate: number
    non_refundable: boolean
    special_request: string
  }[] = []
  if (hotels && hotels.length) {
    hotels.map((hotel: any, hotelIndex: number) => {
      const roomsInitialData: {
        availability: boolean
        cancel_upto: string
        room_id: number
        room_type: string
        system_price: number
        sell_price: number
        booking_code: string
        purchase_price_usd: number
        purchase_price_original: number | null
        conversion_rate: number
        original_currency: string | null
        optional_events: any[]
        selected_event_ids: number[]
        adults: {prefix: string; first_name: string; last_name: string; pan_number: string}[]
        children: {prefix: string; first_name: string; last_name: string; age: any}[]
      }[] = []
      hotel.room_info.map((room: any, roomIndex: number) => {
        const adultsInitialData = []
        const childInitialData = []
        for (let i = 0; i < room.searchData.adult; i++) {
          adultsInitialData.push({
            prefix: 'mr',
            first_name: '',
            last_name: '',
            pan_number: '',
          })
        }
        for (let i = 0; i < room.searchData.child_count; i++) {
          childInitialData.push({
            prefix: 'mr',
            first_name: '',
            last_name: '',
            age: room.searchData.child[i].age,
            with_bed: room.searchData.child[i].child_bed_type,
          })
        }
        // Get purchase_price_usd from the selected inclusion in inclusion_prices
        const selectedInclusionKey =
          room.selectedInclusion || Object.keys(room.roomData.inclusion_prices || {})[0] || 'room'
        const selectedInclusionData = room.roomData.inclusion_prices?.[selectedInclusionKey] || {}
        const purchasePriceUsd = selectedInclusionData.purchase_price_usd || room.roomData.price
        const purchasePriceOriginal = selectedInclusionData.purchase_price_original ?? null

        roomsInitialData.push({
          availability: room.roomData.availability,
          cancel_upto: room.roomData.cancel_upto,
          sell_price: room.roomData.price,
          system_price: room.roomData.price,
          booking_code: room.roomData.booking_code,
          purchase_price_usd: purchasePriceUsd,
          purchase_price_original: purchasePriceOriginal,
          conversion_rate: hotel.hotel.conversion_rate,
          original_currency: room.roomData.original_currency ?? null,
          // Priced by the API for this room's pax. The checkout only sums these;
          // it never computes an event price itself.
          optional_events: room.roomData.optional_events ?? [],
          selected_event_ids: [],
          room_id: room.roomData.id,
          room_type: `${selectedInclusionKey.toUpperCase()}`,
          adults: adultsInitialData,
          children: childInitialData,
        })
      })
      hotelsInitialData.push({
        hotel_id: hotel.hotel.id,
        check_in: hotel.booking_info.check_in,
        check_out: hotel.booking_info.check_out,
        total_night: hotel.booking_info.total_night,
        total_rooms: hotel.booking_info.total_rooms,
        rooms: roomsInitialData,
        conversion_rate: hotel.hotel.conversion_rate,
        non_refundable: hotel.booking_info.non_refundable,
        special_request: '',
      })
    })
  }
  return hotelsInitialData
}
